import { Button, EButtonColor } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import { FC } from 'react';

export interface IFeedbackInitialView {
  onHandleLaterClick: () => void;
  onHandleNegativeClick: () => void;
  onHandlePositiveClick: () => void;
}

export const FeedbackInitialView: FC<IFeedbackInitialView> = ({
  onHandlePositiveClick,
  onHandleNegativeClick,
  onHandleLaterClick,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <p>{t('FeedbackDialog.Initial.Description')}</p>
      <div className="feedback-buttons">
        <Button
          label={t('FeedbackDialog.Initial.PositiveBtn')}
          color={EButtonColor.blue}
          onClick={onHandlePositiveClick}
        />
        <Button
          label={t('FeedbackDialog.Initial.NegativeBtn')}
          color={EButtonColor.white}
          onClick={onHandleNegativeClick}
        />
        <Button label={t('FeedbackDialog.Initial.LaterBtn')} color={EButtonColor.white} onClick={onHandleLaterClick} />
      </div>
    </div>
  );
};
